export default "__VITE_ASSET__DKHQkB_I__"